import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ApiHandlerService } from '../api-handler.service';

declare let $: any;
@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.css']
})
export class PartnerComponent implements OnInit {

  partnerForm;
  submit = false;
  private apiUrl = `${environment.apiUrl}/become-partner`;
  constructor(private fb: FormBuilder, private apiHandler: ApiHandlerService) { }

  ngOnInit() {
    this.partnerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      name: ['', [Validators.required, Validators.pattern('^\\s*[a-zA-Z ]*\\s*$')]],
      contact: ['', Validators.pattern(/^(0|[1-9]\d*)$/)],
      companyName: [''],
      jobTitle: [''],
      msg: ['']
    })
  }

  get partnerFormControl() {
    return this.partnerForm.controls;
  }

  becomePartner(){
    this.submit = true;
    if(this.partnerForm.valid){
      this.partnerForm.value.name = this.partnerForm.value.name.trim();
      this.partnerForm.value.email = this.partnerForm.value.email.trim();
      this.partnerForm.value.companyName = this.partnerForm.value.companyName ? this.partnerForm.value.companyName.trim() : this.partnerForm.value.companyName;
      this.partnerForm.value.jobTitle = this.partnerForm.value.jobTitle ? this.partnerForm.value.jobTitle.trim() : this.partnerForm.value.jobTitle;
      this.partnerForm.value.msg = this.partnerForm.value.msg ? this.partnerForm.value.msg.trim() : this.partnerForm.value.msg;
      this.apiHandler.becomePartner(this.apiUrl, this.partnerForm.value).subscribe(
        result => {
          console.log(result);
          $('#thanks-modal').modal('show');
          this.partnerForm.reset();
          this.submit = false;
      },
      err=>{
        console.error("Become partner Error ==>", err);
        
      }
      )
    }
  }

}
